export class AddressProvider {
    public limit: number;

    constructor(limit = 5) {
        this.limit = limit;
    }

    async search({ query }: { query: string }) {
        if (!query || query.length < 3) return [];

        try {
            const res = await fetch(
                `https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(
                    query
                )}&limit=${this.limit}`
            );

            if (!res.ok) return [];

            const data = await res.json();

            return (data.features || []).map((f: any) => ({
                x: f.geometry.coordinates[0],
                y: f.geometry.coordinates[1],
                label: f.properties.label,
                address: f.properties.name,
                city: f.properties.city,
                zipCode: f.properties.postcode,
                raw: f.properties,
            }));
        } catch (err) {
            console.error("Geo search failed", err);
            return [];
        }
    }
}
